import React from 'react';
import LearningContentDetailTable from './LearningContentDetailTable';
import type { AnnualCrossTopicProgramPlanDocumentPayload } from '../../utils/documentExportPreviewStorage';

export type AnnualCrossTopicProgramPlanExportDocumentProps = {
  payload: AnnualCrossTopicProgramPlanDocumentPayload;
  seqColumnLabel?: string;
};

const AnnualCrossTopicProgramPlanExportDocument = React.forwardRef<
  HTMLDivElement,
  AnnualCrossTopicProgramPlanExportDocumentProps
>(function AnnualCrossTopicProgramPlanExportDocument({ payload, seqColumnLabel }, ref) {
  const { scope, scopeLabel, documentTitle, groups } = payload;

  return (
    <div
      ref={ref}
      className="cp-document-export-preview-sheet cp-annual-cross-topic-detail-print-root cp-annual-cross-topic-program-plan-print-root"
    >
      <div className="cp-annual-cross-topic-program-plan-doc-title" data-pdf-element="header">
        <span className={`cp-annual-cross-topic-detail-scope cp-annual-cross-topic-detail-scope--${scope}`}>
          {scopeLabel}
        </span>
        <span className="cp-annual-cross-topic-program-plan-doc-title-text">{documentTitle}</span>
      </div>
      {groups.map((group) => (
        <section key={group.topic} className="cp-annual-cross-topic-program-plan-group">
          <div className="cp-annual-cross-topic-detail-subtitle cp-annual-cross-topic-program-plan-group-topic">
            <span className="cp-annual-cross-topic-detail-topic" title={group.topic}>
              {group.topic}
            </span>
          </div>
          <div className="cp-annual-cross-topic-detail-table-wrap">
            <LearningContentDetailTable rows={group.rows} seqColumnLabel={seqColumnLabel} />
          </div>
        </section>
      ))}
    </div>
  );
});

export default AnnualCrossTopicProgramPlanExportDocument;
